import { Route, Routes } from 'react-router-dom';

import { ProtectedRoute } from './protectedrouter';

import ecsroutes from '../modules/ecs/router';
import rsroutes from '../modules/rhymscan/router';
import caproutes from '../modules/cap/router';
import vaptroutes from '../modules/vapt/router';
import tiproutes  from  '../modules/tip/router'
import socroutes  from  '../modules/soc/router'

import Login from '../components/Login';
import RequestForgotPassword from '../components/RequestForgotPassword';
import ForgotPasswordVerification from "../components/ForgotPasswordVerification";
import NewPasswordConfirmation from "../components/NewPasswordConfirmation";
import Companies from '../components/Companies';
import UsersListCAP from '../components/CapUsers';
import UsersListECS from '../components/Users';
import CapCompanies from '../components/CapCompanies';
import Companyprofile from '../components/Companyprofile';
import AddCompany from '../components/AddCompany';
import Profile from '../components/Profile';
import AddPartnerCompany from '../components/AddPartnerCompany';
import Adduser from '../components/AddUser';
import Editcompany from '../components/EditCompany';
import MyProfile from '../components/MyProfile';
import UpdatePassword from 'components/UpdatePassword';
import IntegratedDashboardPage from '../components/IntegratedDashboardPage'

import ConfigureServiceWeightages from '../components/ConfigureServiceWeightages';

import UpdateProfile from '../components/UpdateProfile';
import MainLayout from '../components/layouts/MainLayoutPage';
import CRQDashboardPage from '../modules/crq/components/DashboardPage';
import RiskQuantPage from '../modules/crq/components/RiskQuantPage';
import RiskScenariosPage from '../modules/crq/components/RiskScenariosPage';
import CRQUserGuidePage from '../modules/crq/components/UserGuidePage';


const baseRoutes = [
    {
        path: "/",
        element: <Login />,
        name: "login",
    },
    {
        path: "/login",
        element: <Login />,
        name: "login",
    },
    {
        path: "/forgot-password-verification",
        element: <ForgotPasswordVerification />,
        name: "forgot-password",
       
    },
    {
        path: "/Request-Forgot-Password",
        element: <RequestForgotPassword />,
        name: "Request-Forgot-Password",
    },
    {
        path: "/new-password-confirmation",
        element: <NewPasswordConfirmation />,
        name: "new-password-confirmation",
    },
    {
        path: "/companies",
        element: <ProtectedRoute>   <MainLayout>
        <Companies />
        </MainLayout></ProtectedRoute> ,
        name: "Companies"
    },
    {
        path: "/capcompanies",
        element: <ProtectedRoute>   <MainLayout>
        <CapCompanies />
        </MainLayout> </ProtectedRoute> ,
        name: "CapCompanies"
    },
    {
        path: "/cap/users",
        element:<ProtectedRoute><MainLayout> <UsersListCAP /> </MainLayout></ProtectedRoute> ,
        name: "CapUsers"
    }, 
    {
        path: "/ecs/users",
        element:<ProtectedRoute> <MainLayout><UsersListECS /></MainLayout></ProtectedRoute>  ,
        name: "CapUsers"
    }, 
    {
        path: "company-profile",
        element: <ProtectedRoute><MainLayout> <Companyprofile /> </MainLayout></ProtectedRoute>,
        name: "Comapnyprofile"
    },
    {
        path: "profile/:userId",
        element: <ProtectedRoute> <MainLayout><Profile/> </MainLayout></ProtectedRoute>,
        name: "Profile"
    },
    {
        path: "/add-company",
        element: <ProtectedRoute> <MainLayout>
        <AddCompany/>
        </MainLayout> </ProtectedRoute>,
         name: "Addcompany"
    },
    {
        path: "add-user/:companyId",
        element: <ProtectedRoute> <MainLayout><Adduser/> </MainLayout></ProtectedRoute>,
        name: "Adduser"
    },
    {
        path: "company-edit/:companyId",
        element: <ProtectedRoute><MainLayout> <Editcompany/> </MainLayout></ProtectedRoute>,
        name: "Editcompany"
    },
    {
        path: "/update-profile/:userId",
        element : <ProtectedRoute> <MainLayout><UpdateProfile /></MainLayout> </ProtectedRoute>,
        name: "update-profile",
    },
      {   
        path: "/add-partnercompany",
        element: <ProtectedRoute> <MainLayout><AddPartnerCompany/></MainLayout> </ProtectedRoute>,
        name: "AddPartnerCompany"
    },

     {
        path:'/integrated-dashboard',
        element: <ProtectedRoute> 
            <MainLayout>
            <IntegratedDashboardPage/> 
            </MainLayout>
            </ProtectedRoute>,
     },
     {
        path:'/myprofile' ,
        element: <ProtectedRoute> <MainLayout> <MyProfile/> </MainLayout></ProtectedRoute>,
        name:"MyProfile",

     },
     {   
        path: "/update-password",
        element: <ProtectedRoute> <MainLayout><UpdatePassword/></MainLayout> </ProtectedRoute>,
        name: "UpdatePassword"
    }, 
    {   
        path: "/update-service-weightage",
        element: <ProtectedRoute> <MainLayout><ConfigureServiceWeightages/></MainLayout> </ProtectedRoute>,
        name: "UpdateServiceWeightage"
    },  
  ];

  const integratedRoutes = [
  ];

  const adminRoutes = [

  ];

  const crqRoutes=[
    {
        path: "/crq/dashboard",
        element: <ProtectedRoute> 
                    <MainLayout>
                        <CRQDashboardPage/>
                    </MainLayout> 
                 </ProtectedRoute>,
        name: "crq-dashboard"
    },
    {
        path: "/crq/riskquant",
        element: <ProtectedRoute> 
                    <MainLayout>
                        <RiskQuantPage/>
                    </MainLayout> 
                 </ProtectedRoute>,
        name: "crq-riskquant"
    },
    {
        path: "/crq/riskscenarios",
        element: <ProtectedRoute> 
                    <MainLayout>
                        <RiskScenariosPage/>
                    </MainLayout> 
                 </ProtectedRoute>,
        name: "crq-riskscenarios"
    },
    {
        path: "/crq/user-guide",
        element: <ProtectedRoute> 
                    <MainLayout>
                        <CRQUserGuidePage/>
                    </MainLayout> 
                 </ProtectedRoute>,
        name: "crq-user-guide"
    },
  ];
  // Combine all routes
const routes = [...baseRoutes, ...integratedRoutes, ...adminRoutes, ...ecsroutes, ...rsroutes, ...caproutes, ...crqRoutes, ...vaptroutes, ...tiproutes,...socroutes];

// Define your React Router component
const AppRouter = () => (
    <Routes>
        {routes.map((route, index) => (
            <Route
                key={index}
                path={route.path}
                element={route.element}
            >
                {route.children && route.children.map((childRoute, childIndex) => (
                    <Route
                        key={childIndex}
                        path={childRoute.path}
                        element={childRoute.element}
                    />
                ))}
            </Route>
        ))}
        
    </Routes>
);

export default AppRouter;